import React from 'react';
import { Link, useLocation } from 'wouter';
import { Container, Nav } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';

function AppNavigation() {
  const [location] = useLocation();
  const { isAdmin } = useAuth();

  if (!isAdmin()) {
    return null;
  }

  return (
    <div className={ 'dark-header'}>
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Nav className="border-0" style={{ marginLeft: '100px' }}>
          <Nav.Item>
            <Nav.Link
              as={Link}
              href="/"
              active={location === '/'}
            >
              Kiosk
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              as={Link}
              href="/reports"
              active={location.startsWith('/reports')}
            >
              Reports
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              as={Link}
              href="/admin/classes"
              active={location.startsWith('/admin/classes')}
            >
              Classes
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              as={Link}
              href="/logout"
            >
              Logout
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Container>
    </div>
  );
}
export default AppNavigation;
